import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
const SlowestApiComponent = ({ slowestApi }) => {
    console.log("slowestAPIs==========>", slowestApi);
    if (!slowestApi || slowestApi.length === 0) {
        return <div className='text-center py-5'>No data available</div>;
    }

    // Prepare dataset for BarChart
    const dataset = slowestApi.map(item => ({
        api: item._id.replace("/api/v1/tradingApis", ""),
        latency: item.avgLatency !== null ? item.avgLatency : 0,
    }));

    const chartSetting = {
        xAxis: [
            {
                label: 'Latency (ms)',
            },
        ],
        height: 400,
    };

    return (
        <BarChart
            dataset={dataset}
            yAxis={[{ scaleType: 'band', dataKey: 'api' }]}
            series={[{ dataKey: 'latency', label: 'API Latency (ms)' }]}
            layout="horizontal"
            {...chartSetting}
        />
    );
}
export default SlowestApiComponent;
